module.exports = __webpack_public_path__ + "img/img11.c7ac1f2c.png";